module.exports = __webpack_public_path__ + "fonts/la-solid-900.4184d74.eot";